import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cn } from '@/lib/utils'

const Tabs      = TabsPrimitive.Root
const TabsContent = TabsPrimitive.Content

function TabsList({ className, ...props }) {
  return (
    <TabsPrimitive.List
      className={cn('inline-flex h-10 items-center justify-start rounded-none border-b border-[hsl(var(--border))] bg-[hsl(var(--muted))] p-0 w-full', className)}
      {...props}
    />
  )
}

function TabsTrigger({ className, ...props }) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap px-4 py-2 text-sm font-medium text-[hsl(var(--muted-foreground))] border-b-2 border-transparent transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-[hsl(var(--primary))] data-[state=active]:text-[hsl(var(--primary))] data-[state=active]:font-semibold cursor-pointer hover:text-[hsl(var(--foreground))]',
        className
      )}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
